module.exports = __webpack_public_path__ + "static/media/Pachirisu_gaussian2.218583bf.png";